import Login from "./Login";
import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import logo_min from "assets/cloud21/logo-min.png";
import { useLocation } from "react-router-dom";
import ForgotPassword from "./ForgotPassword";
import "./Login.css";
import { ViewStateEnum } from "constants/EnumViewState";
import { FirstAccess } from "./FirstAccess";
import { ResetPassword } from "./ResetPassword";

const LoginScreen: React.FC = () => {
  const [viewState, setViewState] = useState<ViewStateEnum>(ViewStateEnum.LOGIN);
  const [urlToken, setUrlToken] = useState<string | null>("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    if (searchParams.has("redefinir-senha")) {
      setViewState(ViewStateEnum.RESET_PASSWORD);
      setUrlToken(searchParams.get("redefinir-senha"));
    } else if (searchParams.has("primeiro-acesso")) {
      setViewState(ViewStateEnum.FIRST_ACCESS);
      setUrlToken(searchParams.get("primeiro-acesso"));
    }
  });

  const renderHeaderLoginScreen = () => {
    return (
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <img src={logo_min} alt="logo group condomínios" style={{ width: "3vw" }} />
          <div>
            <b>GROUP</b> condomínios
          </div>
        </div>
        {viewState === ViewStateEnum.FORGOT_PASSWORD && (
          <div
            onClick={() => {
              setViewState(ViewStateEnum.LOGIN);
            }}
            className={"botao-voltar-login"}
          >
            Login
          </div>
        )}
      </div>
    );
  };

  const renderContentLoginScreen = () => {
    return (
      <>
        {viewState === ViewStateEnum.LOGIN && <Login changeViewState={setViewState} />}

        {viewState === ViewStateEnum.FORGOT_PASSWORD && <ForgotPassword />}

        {viewState === ViewStateEnum.RESET_PASSWORD && (
          <ResetPassword urlToken={urlToken !== null ? urlToken : ""} />
        )}

        {viewState === ViewStateEnum.FIRST_ACCESS && (
          <FirstAccess urlToken={urlToken !== null ? urlToken : ""} />
        )}
      </>
    );
  };

  return (
    <div className="d-flex justify-content-between" style={{ backgroundColor: "#fff" }}>
      <div style={{ width: "42%" }}>
        <Container className={`p-4 wrap-login100`}>
          {renderHeaderLoginScreen()}
          {renderContentLoginScreen()}
        </Container>
      </div>
      <div className={"container-login100"} style={{ width: "58vw" }} />
    </div>
  );
};
export default LoginScreen;
